// extracted by mini-css-extract-plugin
export default {"badge":"badge_badge__FpO1r"};